import type { PlayerStanding } from "@/types/api";
import { Trophy, Medal, Award } from "lucide-react";

interface PodiumProps {
  players: PlayerStanding[];
  myPlayerId: string;
}

const podiumConfig = [
  { place: 1, order: "order-2", height: "h-28", iconSize: "h-8 w-8", bgColor: "bg-warning/20", borderColor: "border-warning/40", textColor: "text-warning", Icon: Trophy },
  { place: 2, order: "order-1", height: "h-20", iconSize: "h-6 w-6", bgColor: "bg-accent/15", borderColor: "border-accent/30", textColor: "text-text-secondary", Icon: Medal },
  { place: 3, order: "order-3", height: "h-14", iconSize: "h-6 w-6", bgColor: "bg-primary/15", borderColor: "border-primary/30", textColor: "text-text-secondary", Icon: Award },
];

export default function Podium({ players, myPlayerId }: PodiumProps) {
  const sorted = [...players].sort((a, b) => (b.totalScore ?? b.approvedCount) - (a.totalScore ?? a.approvedCount));
  const top3 = sorted.slice(0, 3);

  if (top3.length === 0) return null;

  return (
    <div className="flex animate-scale-in items-end justify-center gap-3 pb-4 pt-2">
      {top3.map((player, i) => {
        const config = podiumConfig[i]!;
        const isMe = player.playerId === myPlayerId;
        const IconComponent = config.Icon;

        return (
          <div
            key={player.playerId}
            className={`flex flex-1 flex-col items-center ${config.order}`}
          >
            {/* Player info */}
            <div className={`mb-2 flex h-12 w-12 items-center justify-center rounded-full ${config.bgColor} ${isMe ? "ring-2 ring-primary" : ""}`}>
              <IconComponent className={`${config.iconSize} ${config.textColor}`} />
            </div>
            <p className={`mb-1 max-w-full truncate text-center text-sm font-bold ${isMe ? "text-primary" : "text-text"}`}>
              {player.displayName}
            </p>
            <p className="mb-2 text-xl font-extrabold text-text">
              {player.totalScore ?? player.approvedCount}
              <span className="text-sm font-medium text-text-secondary">/{player.totalItems}</span>
            </p>

            {/* Podium block */}
            <div
              className={`${config.height} w-full rounded-t-xl border-2 ${config.borderColor} ${config.bgColor}`}
            />
          </div>
        );
      })}
    </div>
  );
}
